import React from 'react';

export const SensorCategory = (props) => (
    <svg {...props} viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.2 27H14.6V18.3L19.9 15.4L25.2 18.3V27ZM9.5 11.7C7.4 13.8 4.1 13.8 2 11.7C0 9.7 0 6.3 2 4.2L5.8 0.5L9.5 4.2C11.6 6.3 11.6 9.7 9.5 11.7ZM26 7L24.2 8.8V11.3H21.7L19.9 13.1L18.1 11.3H15.6V8.8L13.8 7L15.6 5.2V2.7H18.1L19.9 0.9L21.7 2.7H24.2V5.2L26 7ZM11.5 21.7C11.5 24.9 8.9 27.5 5.7 27.5C2.5 27.5 0 24.9 0 21.7C0 18.5 2.6 15.9 5.8 15.9C9 15.9 11.5 18.5 11.5 21.7ZM8.2 21.7C8.2 20.4 7.1 19.3 5.8 19.3C4.5 19.3 3.4 20.4 3.4 21.7C3.4 23 4.5 24.1 5.8 24.1C7.1 24.2 8.2 23.1 8.2 21.7Z" />
    </svg>
);
export default SensorCategory;
